// The public booking link a promoter shares for one of their events
// (Instagram, WhatsApp, their own site, a printed QR code).
//
// It points at /apply/:eventId rather than /event/:slug on purpose: the slug
// is regenerated whenever the event is renamed, and a QR code on a printed
// flyer can't be updated. /apply resolves the id to the current slug and
// lands on the event page with `?apply=1`, which shows the brand the
// "book your space" banner.
//
// `lang` is the language the promoter shared it in: the link preview and the
// event page follow it (`?lng=` there), unless the visitor already chose a
// language on the site.
//
// `source` ends up as `?src=` on the event page. Nothing reads it yet; it is
// there so links already in the wild (QR codes especially) carry it once we
// attribute applications to where they came from.

export const APPLY_SOURCES = ['link', 'qr'];
export const APPLY_LANGS = ['pt', 'en'];

export const applyLinkFor = (event, { source, lang } = {}) => {
  if (!event?.id) return null;
  const origin =
    typeof window !== 'undefined' ? window.location.origin : 'https://there2b.com';
  const url = new URL(`/apply/${encodeURIComponent(event.id)}`, origin);
  if (source && APPLY_SOURCES.includes(source)) {
    url.searchParams.set('src', source);
  }
  if (lang && APPLY_LANGS.includes(lang)) {
    url.searchParams.set('lang', lang);
  }
  return url.toString();
};

// Only published events are visible to brands, so a link to anything else
// would 404 for them.
export const canShareApplyLink = (event) =>
  String(event?.status || '').toLowerCase() !== 'draft';
